import { create } from 'zustand';
import { Theme, getStoredTheme, saveTheme, themes, getThemeRgbVariants } from '../config/themes';

interface ThemeState {
  currentTheme: Theme;
  setTheme: (themeId: string) => void;
  applyTheme: (theme: Theme) => void;
}

/**
 * Apply theme colors and RGB variants as CSS variables
 */
const applyThemeToDom = (theme: Theme) => {
  const root = document.documentElement;

  // Apply regular theme colors
  Object.entries(theme.colors).forEach(([key, value]) => {
    // Convert camelCase to kebab-case for CSS variables
    const cssVarName = `--theme-${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
    root.style.setProperty(cssVarName, value);
  });

  // Apply RGB variants for rgba() usage in glassmorphic effects
  const rgbVariants = getThemeRgbVariants(theme);
  Object.entries(rgbVariants).forEach(([key, value]) => {
    const cssVarName = `--theme-${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
    root.style.setProperty(cssVarName, value);
  });
};

export const useThemeStore = create<ThemeState>((set) => ({
  currentTheme: getStoredTheme(),

  setTheme: (themeId: string) => {
    const theme = themes[themeId];
    if (theme) {
      saveTheme(themeId);
      set({ currentTheme: theme });
      applyThemeToDom(theme);
    }
  },

  applyTheme: (theme: Theme) => {
    applyThemeToDom(theme);
  },
}));

// Apply initial theme on module load
const initialTheme = getStoredTheme();
applyThemeToDom(initialTheme);
